import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { useGetLotsQuery } from 'features/lots/lotSlice';
import { useGetVehicleTypesQuery } from 'features/vehicles/vehicleSlice';
import LoadingSpinner from 'components/LoadingSpinner';
import AddPricing from '../../CreateActivityAndPricing/ActivityItemPricing/AddPricing';
import { saveBundleStepData } from '../bundleStateSlice';
import { CREATE_BUNDLE_STEP_KEYS } from '../createBundleConsts';
import { useActivityItemPricingStepStyles } from '../../CreateActivityAndPricing/ActivityItemPricing/ActivityItemPricingStyles';

const BundlePricingStep = () => {
    const classes = useActivityItemPricingStepStyles();
    const dispatch = useDispatch();
    const pricingData = useSelector(state => state.bundleState.steps[CREATE_BUNDLE_STEP_KEYS.PRICING]) || {};

    const { data: clients, isLoading: isLoadingClients } = useGetClientsQuery(null);
    const { data: lots, isLoading: isLoadingLots } = useGetLotsQuery();
    const { data: vehicleTypes, isLoading: isLoadingVehicleTypes } = useGetVehicleTypesQuery();

    const pricingItems = pricingData.pricingItems || [];
    const editingPricingKeys = pricingData.editingPricingKeys || [];

    const setPricingItems = (items) => {
        if (pricingData.pricingItems === items) return;
        dispatch(saveBundleStepData({
            stepKey: CREATE_BUNDLE_STEP_KEYS.PRICING,
            data: { pricingItems: items }
        }));
    };

    const onPricingUnsavedChanges = (pricingKey, hasUnsaved) => {
        const nextEditingPricingKeys = hasUnsaved
            ? (editingPricingKeys.includes(pricingKey) ? editingPricingKeys : [...editingPricingKeys, pricingKey])
            : editingPricingKeys.filter(key => key !== pricingKey);

        const somePricingHasUnsavedEdits = nextEditingPricingKeys.length > 0;

        if (
            pricingData.somePricingHasUnsavedEdits === somePricingHasUnsavedEdits &&
            pricingData.editingPricingKeys === nextEditingPricingKeys
        ) return;

        dispatch(saveBundleStepData({
            stepKey: CREATE_BUNDLE_STEP_KEYS.PRICING,
            data: { editingPricingKeys: nextEditingPricingKeys, somePricingHasUnsavedEdits }
        }));
    };

    const isLoading = isLoadingClients || isLoadingLots || isLoadingVehicleTypes;

    if (isLoading) {
        return <LoadingSpinner loading={true} />;
    }

    return (
        <div className={classes.container}>
            <div className={classes.sectionHeader}>
                <h3>Pricing Configuration</h3>
                <p>Add pricing configurations for this bundle.</p>
            </div>
            <AddPricing
                pricingItems={pricingItems}
                setPricingItems={setPricingItems}
                onUnsavedChanges={onPricingUnsavedChanges}
                lots={lots}
                clients={clients}
                vehicleTypes={vehicleTypes}
                usePricingCalculator={false}
                requireVendor={false}
            />
        </div>
    );
};

export default BundlePricingStep;
